import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    width: 540,
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  description: {
    fontSize: 16,
    paddingTop: theme.spacing(2),
    lineHeight: 2,
  },
}));
